<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/baggage-step1')"></span>
    </div>
    <div class="title">费用计算器</div>
    <div class="box-img">
      <img class="full-image" src="../../assets/img/baggage/box.jpg">
    </div>
    <div class="text">
      <div class="text-main">
        预估行李使用纸箱数，可计算出大概运费
      </div>
    </div>
    <div class="option-container">
      <div class="item">
        <span class="qty-label">预计纸箱数</span>
        <div class="counter">
          <v-counter @plus="plus" @minus="minus" :num='order.data.boxQty'>
          </v-counter>
        </div>
      </div>

      <div class="item">
        <span class="qty-label">预计重量</span>
        <span class="qty-label">{{10*order.data.boxQty}}~{{16*order.data.boxQty}} KG</span>
      </div>

      <div class="item">
        <span class="qty-label">邮寄运费</span>
        <span class="qty-label">${{16*10*order.data.boxQty}} ~ ${{17.5*16*order.data.boxQty}}</span>
      </div>

      <div class="item">
        <span class="qty-label">取件打包</span>
        <span class="qty-label">$60 / 小时 + $50 起出车回程费</span>
      </div>
    </div>

    <img class="progress" src="../../assets/img/baggage/progress.png">

    <div class="btn-box-fix">
      <div class="slogan">点击查看
        <span class="color-orange">
          <span @click="$router.push('/baggage-price');">收费详情及更多介绍</span>
        </span>
      </div>
      <div class="btn-container">
        <div class="btn active" @click="checkSubmit()">开始下单</div>
      </div>
    </div>

    <img :src="pixelURL('baggage','yugu')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'baggage-step0',
  data () {
    return {
      order:{},
    }
  },
  methods: {
    checkSubmit(){
      this.orderUpdateAll('/baggage-step2');
    },

    isSkipable(){
      if(this.order.data.move_other_valuables){
        return true;
      }
      let obj = this.tempValuable;
      let summary = 0;
      for (let item in obj) {
        summary = summary + obj[item];
      }
      if(summary){
        return true;
      }
      else{
        return false;
      }
    },
    plus: function () {
      this.order.data.boxQty = this.order.data.boxQty +1;
      if(this.order.data.boxQty>20){
        this.order.data.boxQty=20;
      }
		},
    minus: function () {
      this.order.data.boxQty = this.order.data.boxQty -1;
      if(this.order.data.boxQty<1){
        this.order.data.boxQty=1;
      }
		},
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "baggage"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.box-img{
  width:90%;
  margin:6px auto 0 auto;
  text-align:center;
}

.progress{
  width:90%;
  display:block;
  margin:30px auto 0 auto;
}

.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}

.btn-box-fix .btn.active{
  margin-left:0;
  margin-top:0;
}

.text{
  padding:1em 40px;
  .text-main{
    color:#888;
    text-align:center;
  }
}

.option-container{
  padding:0 40px;
}
.qty-label{
	display: inline-block;
	font-weight: 100;
	vertical-align: top;
	padding: 12px 0 0 0;
	color: #000;
}
.item{
  display: flex;
	justify-content:space-between;
  align-items:left;
  margin-bottom:6px;
  img{
    width:60px;
  }
  .counter{
    padding-top:8px;
    margin-left:14px;
  }
}

.other-text{
  font-size:0.9em;
  border-left:0.5px solid #e5e5e5;
  border-right:0.5px solid #e5e5e5;
}
.container /deep/ .qty .number{
  width:40px;
}

</style>



// WEBPACK FOOTER //
// src/pages/baggage/calc.vue